import { Id, id } from "./id";
import { Identifiable } from "./identifiable";
import { Resource } from "./resource";

type OrganizationalUnit = {
  uuid: string;
  name: string;
  rankKey: string;
  parentUuid?: Id;
  hasChildren?: boolean;
  resources?: Identifiable<Resource>[];
};

const organizationalUnit: OrganizationalUnit = {
  uuid: id,
  name: "",
  rankKey: "",
};

export type { OrganizationalUnit };

export { organizationalUnit };
